<template>
  <div class="v-tariff-group-update">
    <form class="form" @submit.prevent="updateGroup" autocomplete="nope">
      <div class="row">
        <div class="col-3">
          <div class="form-group">
            <input class="form-control" type="text" autocomplete="none"
                   v-model="inputs.name "/>
          </div>
        </div>
        <div class="col-5">
          <multiselect
            v-model="inputs.tariffs"
            :multiple="true"
            selectLabel=""
            deselectLabel=""
            :options="tariffList"
            :close-on-select="false"
            :clear-on-select="false"
            placeholder="Выберите тарифы"
            label="name"
            track-by="id">
            <template slot="selection"
                      slot-scope="{ tariffs, search, isOpen }">
              <span class="multiselect__single"
                    v-if="inputs.tariffs.length &amp;&amp; !isOpen">
                {{ inputs.tariffs.length }} тариф выбран
              </span>
            </template>
          </multiselect>
        </div>
        <div class="col-4">
          <button type="submit" class="btn btn-primary">
             Обновить группу
           </button>
         </div>
      </div>
    </form>
   </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Multiselect from 'vue-multiselect';

export default {
  name: 'v-tariff-group-update',
  components: { Multiselect },
  props: {
    group: Object,
    tariffList: Array,
  },
  data() {
    return {
      inputs: {
        name: '',
        tariffs: [],
      },
      formatTariffs: [],
    };
  },
  computed: {
    ...mapState('tariff', ['error']),
  },
  methods: {
    ...mapActions('tariff', ['updateTariffGroup', 'deleteTariffGroup']),
    refactoringTariffs() {
      let i;
      for (i = 0; i < this.inputs.tariffs.length; i += 1) {
        this.formatTariffs.push(this.inputs.tariffs[i].id);
      }
      this.inputs.tariffs = this.formatTariffs;
    },
    updateGroup() {
      this.refactoringTariffs();
      const newData = { tariffGroupId: this.group.id, data: this.inputs };
      this.updateTariffGroup(newData)
        .then(() => {
          if (!this.error) {
            this.$notify({
              group: 'message',
              title: 'New message:',
              type: 'success',
              text: 'Группа тарифов успешно обновлена!',
            });
          } else {
            this.$notify({
              group: 'message',
              title: 'New message:',
              type: 'error',
              text: 'Произошла ошибка!',
            });
          }
        })
        .finally(() => { this.close(); });
    },
    deleteGroup() {
      this.deleteTariffGroup(this.group.id)
        .then(() => {
          if (!this.error) {
            this.$notify({
              group: 'message',
              title: 'New message:',
              type: 'success',
              text: 'Группа тарифов успешно удалена!',
            });
          } else {
            this.$notify({
              group: 'message',
              title: 'New message:',
              type: 'error',
              text: 'Произошла ошибка!',
            });
          }
        })
        .finally(() => { this.close(); });
    },
  },
  mounted() {
    this.inputs.name = this.group.name;
    this.inputs.tariffs = this.group.tariffs;
  },
};
</script>
